import { render, staticRenderFns } from "./AppointmentView.vue?vue&type=template&id=401adb0a&scoped=true"
import script from "./AppointmentView.vue?vue&type=script&lang=ts"
export * from "./AppointmentView.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentView.vue?vue&type=style&index=0&id=401adb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401adb0a",
  null
  
)

export default component.exports